module.exports = __webpack_public_path__ + "static/media/lock-slash.db68bb52.svg";